import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, Input, isDevMode, OnInit, ViewChild } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatList, MatListItem } from '@angular/material/list';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatSidenav, MatSidenavContainer, MatSidenavContent } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { SidenavService } from '@app/core/services/sidenav.service';
import * as fromRoot from '@app/store/reducers';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ExportMenuComponent } from '../../components/export-menu/export-menu.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { LangMenuComponent } from '../../components/lang-menu/lang-menu.component';
import { SidebarComponent } from '../../components/sidebar/sidebar.component';
import { ThemeMenuComponent } from '../../components/theme-menu/theme-menu.component';
import { UserMenuComponent } from '../../components/user-menu/user-menu.component';

@Component({
  selector: 'am-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatSidenavContainer,
    MatSidenav,
    SidebarComponent,
    MatSidenavContent,
    MatList,
    MatListItem,
    MatIcon,
    MatProgressSpinner,
    ExportMenuComponent,
    ThemeMenuComponent,
    LangMenuComponent,
    UserMenuComponent,
    RouterOutlet,
    FooterComponent,
    AsyncPipe,
  ],
  standalone: true,
})
export class LayoutComponent implements OnInit {
  @Input() urlPath: string;

  exportAnalysisRunning$: Observable<boolean>;

  isScreenWide$: Observable<boolean>;

  isDevMode = isDevMode();

  private readonly _store = inject<Store<fromRoot.State>>(Store);
  private readonly _sidenavService = inject(SidenavService);
  private _sidenav: MatSidenav;

  get sidenav(): MatSidenav {
    return this._sidenav;
  }

  @ViewChild('sidenavRef')
  set sidenav(sidenav: MatSidenav) {
    if (sidenav) {
      this._sidenav = sidenav;
      this._sidenavService.setSidenav(this.sidenav);
    }
  }

  ngOnInit(): void {
    this.isScreenWide$ = this._store.pipe(select(fromRoot.getIsScreenWide));
    this.exportAnalysisRunning$ = this._store.pipe(select(fromRoot.getExportAnalysisRunning));
  }

  openSideNav(): void {
    this._sidenavService.open();
  }

  closeSidenav(): void {
    this._sidenavService.close();
  }
}
